import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer section">
      <div className="container">
        <div className="footer__container">
          <div className="footer__identity">
            <h3 className="footer__name">Yegor Cherov</h3>
            <p className="footer__tagline">
              Engineer building software, systems, automation, and hardware.
            </p>
          </div>

          <div>
            <h4 className="footer__title">Navigate</h4>
            <ul className="footer__list">
              <li><a href="#home" className="footer__link">Index</a></li>
              <li><a href="#capabilities" className="footer__link">Capabilities</a></li>
              <li><a href="#work" className="footer__link">Work</a></li>
              <li><a href="#contact" className="footer__link">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="footer__title">Explore</h4>
            <ul className="footer__list">
              <li><a href="#capabilities" className="footer__link">What I do</a></li>
              <li><a href="#work" className="footer__link">All projects</a></li>
              <li><a href="#contact" className="footer__link">Get in touch</a></li>
            </ul>
          </div>

          <div>
            <h4 className="footer__title">Elsewhere</h4>
            <div className="footer__social">
              <a
                href="https://github.com/YegorCherov"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label="GitHub profile"
              >
                <i className="ri-github-line"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/yegor-cherov"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label="LinkedIn profile"
              >
                <i className="ri-linkedin-box-line"></i>
              </a>
              <a
                href="mailto:Yegorcherov@gmail.com"
                className="footer__social-link"
                aria-label="Email Yegor Cherov"
              >
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>
        </div>

        <p className="footer__copy">
          © {currentYear} Yegor Cherov. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;